import React, { FC } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import JournalLG from '../../../assets/Journal-LG.svg?react';
import JournalSM from '../../../assets/Journal-SM.svg?react';
import JournalFull from '../../../assets/JournalBody.svg?react';
import { ComingSoonOverlay } from '../../overlays/coming-soon-overlay';

export const JournalSection: FC = () => {
  const theme = useTheme();
  const isLGAndHigher = useMediaQuery(theme.breakpoints.up('lg'));
  const isMD = useMediaQuery(theme.breakpoints.only('md'));
  const isSMAndBelow = useMediaQuery(theme.breakpoints.down('md'));

  const getResponsiveJournalSVG = () => {
    if (isLGAndHigher) {
      return <JournalFull aria-hidden="true" role="img" />;
    }
    if (isMD) {
      return <JournalLG aria-hidden="true" role="img" />;
    }
    if (isSMAndBelow) {
      return <JournalSM aria-hidden="true" role="img" />;
    }
    // Fallback
    return <JournalFull />;
  };

  return <ComingSoonOverlay>{getResponsiveJournalSVG()}</ComingSoonOverlay>;
};
